module.exports = __webpack_public_path__ + "img/pizzeriano3-pizzas.88be47ee.jpeg";